import {
  SIDEKICK_DOCK_EDGE_OFFSET_PX,
  SIDEKICK_DOCK_WIDTH_PX,
  SIDEKICK_PANEL_WIDTH,
} from '@brightdrop/ai-sidekick';

import {
  GLOBAL_SNACKBAR_STACK_EDGE_OFFSET_PX,
  GLOBAL_SNACKBAR_WIDGET_WIDTH_PX,
} from '~/components/GlobalSnackbarStack/constants';

/**
 * Host identifier sent with each Sidekick request so the backend can
 * route experiments per surface. Matches the value mf-insights sends.
 */
export const SIDEKICK_INTERFACE_NAME = 'csp-web';

/**
 * Viewport width (px) at or above which the stack fits beside the
 * expanded card — the fallback when the viewport is too short to
 * stack them.
 *
 * Counts the card and its gap from the right edge, the gap the stack
 * then keeps from the card, and the width the stack is drawn at.
 * Narrower than this the two cannot share a row either, and the stack
 * yields the corner until the dock minimizes.
 */
export const SIDEKICK_DOCK_STACK_BESIDE_MIN_WIDTH_PX =
  SIDEKICK_DOCK_WIDTH_PX +
  SIDEKICK_DOCK_EDGE_OFFSET_PX +
  GLOBAL_SNACKBAR_STACK_EDGE_OFFSET_PX +
  GLOBAL_SNACKBAR_WIDGET_WIDTH_PX;

/**
 * Viewport width (px) at or above which the stack fits beside the
 * open drawer.
 *
 * The drawer sits flush against the right edge, so this counts its
 * width, the gap the stack keeps from it, and the width the stack is
 * drawn at. Below this there is nowhere to step: the drawer spans the
 * whole viewport at mobile widths, and between there and this
 * threshold the stack's left edge would fall off screen.
 */
export const SIDEKICK_DOCK_STACK_BESIDE_DRAWER_MIN_WIDTH_PX =
  SIDEKICK_PANEL_WIDTH +
  GLOBAL_SNACKBAR_STACK_EDGE_OFFSET_PX +
  GLOBAL_SNACKBAR_WIDGET_WIDTH_PX;
